module.exports = __webpack_public_path__ + "img/DefaultDark.245e7bad.svg";